import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { FAQConstants } from "utils/constants";
//#endregion
//#region components
import DocumentDraftReportBanner from "./banner";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceEmailBanner: React.FC = (props) => {
  const loggedInUserSelfInvoiceEmail = useSelector(
    (store: AppState) => store.auth.selectedCompany.loggedInUserSelfInvoiceEmail
  );

  return (
    <DocumentDraftReportBanner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SelfInvoiceEmailBannerTitle)}
      subTitle={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.SelfInvoiceEmailBannerSubTitle
      )}
      readMoreInfo={{
        url: `${FAQConstants.FAQUrl}/${FAQConstants.ArticleSelfInvoiceEmailUrl}`,
        text: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.DocumentDraft.BannerReadMoreOnSelfInvoiceEmail
        ),
      }}
      userEmail={loggedInUserSelfInvoiceEmail ?? ""}
    />
  );
};

export default SelfInvoiceEmailBanner;
